import { Navigate } from 'react-router'

interface AppNavigateProps {
  to: string
  replace?: boolean
}

/** v6: wraps <Navigate>. Was <Redirect> wrapper in v5 (Layer 2). */
export function AppNavigate({ to, replace }: AppNavigateProps) {
  return <Navigate to={to} replace={replace} />
}
